import { DropdownOption } from '../components/ui/dropdown/dropdown.component';

export interface CountryCurrency {
  cocu_id: number;
  currency_id: number;
  currency_name: string;
  display_logo: string;
  exchange_rate: number;
}

export interface CountryCurrencyData {
  country_id: number;
  country_name: string;
  country_code?: string;
  country_flag?: string;
  currency: CountryCurrency[];
}

const LOCAL_FLAG_BY_COUNTRY_CODE: Record<string, string> = {
  US: 'assets/img/country-flags/America.svg',
  CA: 'assets/img/country-flags/Canada.svg',
  AU: 'assets/img/country-flags/Australia.svg',
  NZ: 'assets/img/country-flags/Australia.svg',
  DE: 'assets/img/country-flags/Germany.svg',
  IT: 'assets/img/country-flags/Italy.svg',
  FR: 'assets/img/country-flags/France.svg',
  ES: 'assets/img/country-flags/Spain.svg',
  JP: 'assets/img/country-flags/Japan.svg',
  GB: 'assets/img/country-flags/United Kingdom.svg',
  PL: 'assets/img/country-flags/Poland.svg',
};

const CURRENCY_SHORT_LABELS: Record<string, string> = {
  'US Dollar': 'USD',
  'Canada Dollar': 'CAD',
  'Australia Dollar': 'AUD',
  'New Zealand Dollar': 'NZD',
  Euro: 'EUR',
  Pound: 'GBP',
  'Polish Zloty': 'PLN',
  Yen: 'YEN',
  Dollars: 'USD',
};

const CURRENCY_DESCRIPTIONS: Record<string, string> = {
  'US Dollar': 'US DOLLARS',
  'Canada Dollar': 'CANADA DOLLARS',
  'Australia Dollar': 'AUSTRALIA DOLLARS',
  'New Zealand Dollar': 'NEW ZEALAND DOLLARS',
  Euro: 'EURO',
  Pound: 'POUND',
  'Polish Zloty': 'POLISH ZLOTY',
  Yen: 'YEN',
  Dollars: 'DOLLARS',
};

/** Source country/currency list aligned with `/countries` API response. */
export const COUNTRY_CURRENCY_LIST: CountryCurrencyData[] = [
  {
    country_id: 1,
    country_name: 'United States',
    country_code: 'US',
    country_flag: 'https://d1quwd2rcgmpnt.cloudfront.net/country_flags/us_flag.svg',
    currency: [{ cocu_id: 1, currency_id: 1, display_logo: '$', currency_name: 'US Dollar', exchange_rate: 1 }],
  },
  {
    country_id: 2,
    country_name: 'Canada',
    country_code: 'CA',
    country_flag: 'https://d1quwd2rcgmpnt.cloudfront.net/country_flags/ca_flag.svg',
    currency: [{ cocu_id: 3, currency_id: 6, display_logo: 'CA$', currency_name: 'Canada Dollar', exchange_rate: 0.7143059968948364 }],
  },
  {
    country_id: 5,
    country_name: 'United Kingdom',
    country_code: 'GB',
    country_flag: 'https://d1quwd2rcgmpnt.cloudfront.net/country_flags/gb_flag.svg',
    currency: [
      { cocu_id: 5, currency_id: 4, display_logo: '£', currency_name: 'Pound', exchange_rate: 1.3201600313186646 },
      { cocu_id: 4, currency_id: 3, display_logo: '€', currency_name: 'Euro', exchange_rate: 1.1605499982833862 },
    ],
  },
  {
    country_id: 7,
    country_name: 'Australia',
    country_code: 'AU',
    country_flag: 'https://d1quwd2rcgmpnt.cloudfront.net/country_flags/au_flag.svg',
    currency: [{ cocu_id: 2, currency_id: 2, display_logo: 'A$', currency_name: 'Australia Dollar', exchange_rate: 0.6979600191116333 }],
  },
  {
    country_id: 9,
    country_name: 'New Zealand',
    country_code: 'NZ',
    country_flag: 'https://d1quwd2rcgmpnt.cloudfront.net/country_flags/nz_flag.svg',
    currency: [{ cocu_id: 8, currency_id: 7, display_logo: 'NZ$', currency_name: 'New Zealand Dollar', exchange_rate: 0.5782170295715332 }],
  },
  {
    country_id: 10,
    country_name: 'Germany',
    country_code: 'DE',
    country_flag: 'https://d1quwd2rcgmpnt.cloudfront.net/country_flags/germany.svg',
    currency: [{ cocu_id: 9, currency_id: 3, display_logo: '€', currency_name: 'Euro', exchange_rate: 1.1605499982833862 }],
  },
  {
    country_id: 11,
    country_name: 'Italy',
    country_code: 'IT',
    country_flag: 'https://d1quwd2rcgmpnt.cloudfront.net/country_flags/italy.svg',
    currency: [{ cocu_id: 10, currency_id: 3, display_logo: '€', currency_name: 'Euro', exchange_rate: 1.1605499982833862 }],
  },
  {
    country_id: 12,
    country_name: 'France',
    country_code: 'FR',
    country_flag: 'https://d1quwd2rcgmpnt.cloudfront.net/country_flags/france_flag.svg',
    currency: [{ cocu_id: 11, currency_id: 3, display_logo: '€', currency_name: 'Euro', exchange_rate: 1.1605499982833862 }],
  },
  {
    country_id: 13,
    country_name: 'Spain',
    country_code: 'ES',
    country_flag: 'https://d1quwd2rcgmpnt.cloudfront.net/country_flags/spain.svg',
    currency: [{ cocu_id: 12, currency_id: 3, display_logo: '€', currency_name: 'Euro', exchange_rate: 1.1605499982833862 }],
  },
  {
    country_id: 14,
    country_name: 'Poland',
    country_code: 'PL',
    country_flag: 'https://d1quwd2rcgmpnt.cloudfront.net/country_flags/poland.svg',
    currency: [
      { cocu_id: 13, currency_id: 3, display_logo: '€', currency_name: 'Euro', exchange_rate: 1.1605499982833862 },
      { cocu_id: 14, currency_id: 8, display_logo: 'PLN', currency_name: 'Polish Zloty', exchange_rate: 0.2721549868583679 },
    ],
  },
  {
    country_id: 15,
    country_name: 'Japan',
    country_code: 'JP',
    country_flag: 'https://d1quwd2rcgmpnt.cloudfront.net/country_flags/japan.svg',
    currency: [{ cocu_id: 15, currency_id: 9, display_logo: '¥', currency_name: 'Yen', exchange_rate: 0.6175609827041626 }],
  },
  {
    country_id: 16,
    country_name: 'Ireland',
    country_code: 'IE',
    country_flag: 'https://d1quwd2rcgmpnt.cloudfront.net/country_flags/japan.svg',
    currency: [{ cocu_id: 16, currency_id: 3, display_logo: '€', currency_name: 'Euro', exchange_rate: 1.1605499982833862 }],
  },
];

function getCountryFlagImage(country: CountryCurrencyData): string | undefined {
  if (country.country_code && LOCAL_FLAG_BY_COUNTRY_CODE[country.country_code]) {
    return LOCAL_FLAG_BY_COUNTRY_CODE[country.country_code];
  }
  return country.country_flag;
}

function toShortLabel(currencyName: string): string {
  return CURRENCY_SHORT_LABELS[currencyName] ?? currencyName.toUpperCase();
}

function toDescription(currencyName: string): string {
  return CURRENCY_DESCRIPTIONS[currencyName] ?? currencyName.toUpperCase();
}

function toDropdownOption(country: CountryCurrencyData, currency: CountryCurrency): DropdownOption {
  return {
    label: country.country_name,
    shortLabel: toShortLabel(currency.currency_name),
    description: toDescription(currency.currency_name),
    value: String(currency.cocu_id),
    image: getCountryFlagImage(country),
    badge: { text: currency.display_logo },
  };
}

/** Native currency when a country supports multiple currencies (e.g. GBP for UK, PLN for Poland). */
function getNativeCurrency(country: CountryCurrencyData): CountryCurrency | undefined {
  if (!country.currency?.length) return undefined;
  if (country.currency.length === 1) return country.currency[0];
  return country.currency.reduce((native, current) => (current.cocu_id > native.cocu_id ? current : native));
}

/** Currency dropdown options (`cocu_id` as value) — one native currency per country. */
export function buildCurrencyDropdownOptions(): DropdownOption[] {
  return COUNTRY_CURRENCY_LIST.flatMap((country) => {
    const currency = getNativeCurrency(country);
    return currency ? [toDropdownOption(country, currency)] : [];
  });
}

/** Country dropdown options (`country_id` as value) — one native currency per country. */
export function buildCountryDropdownOptions(includeAll = true): DropdownOption[] {
  const options: DropdownOption[] = includeAll
    ? [{ label: 'All', shortLabel: 'All', description: 'ALL COUNTRIES', value: '0' }]
    : [];

  for (const country of COUNTRY_CURRENCY_LIST) {
    const currency = getNativeCurrency(country);
    if (!currency) continue;
    options.push({
      ...toDropdownOption(country, currency),
      value: String(country.country_id),
    });
  }

  return options;
}

export function getCurrencyInfoByCocuId(cocuId: string | number): { cocu_id: number; country_id: number } {
  const id = Number(cocuId);
  for (const country of COUNTRY_CURRENCY_LIST) {
    const currency = country.currency?.find((entry) => entry.cocu_id === id);
    if (currency) {
      return { cocu_id: currency.cocu_id, country_id: country.country_id };
    }
  }
  return { cocu_id: 1, country_id: 1 };
}

export const CURRENCY_DROPDOWN_OPTIONS = buildCurrencyDropdownOptions();
export const UNPAID_PAYMENTS_COUNTRY_OPTIONS = buildCountryDropdownOptions();
